import {
  GREY_100,
  GREY_200,
  GREY_400,
  GREY_800,
  RED_500,
  RED_700,
  Symbols,
} from '@mnd-frontend/ui';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import IconAndCaption from './IconAndCaption';
import { UPLOADING_STATES } from './constants';

const idleStyle = css`
  transition: background-color 0.2s ease-out;
  svg {
    path {
      fill: ${GREY_800};
    }
    .cls-1 {
      fill: ${GREY_400};
    }
    path:nth-child(2) {
      transition:
        transform 0.2s ease-out,
        fill 0.2s ease-out;
      transform: translateY(0rem);
    }
    path {
      transition: fill 0.2s ease-out;
    }
  }
  &:hover {
    background-color: ${GREY_200};
    transition: background-color 0s ease-out;
  }
  &:hover:active {
    background-color: ${GREY_100};
  }
  &:hover {
    svg {
      path {
        transition: fill 0.2s ease-out;
        fill: ${RED_700};
      }
      path:first-child {
        fill: ${RED_500};
      }
      path:nth-child(2) {
        transition:
          transform 0.2s ease-out,
          fill 0.2s ease-out;
        transform: translateY(-0.12rem);
      }
    }
  }
  &:hover:active {
    svg {
      transform: scale(0.98);
      path {
        fill: ${RED_700};
      }
      path:first-child {
        fill: ${RED_500};
      }
      path:nth-child(2) {
        transition: transform 0s ease-out;
        transform: translateY(-0.15rem);
      }
    }
  }
`;

const loadingStyle = css`
  @keyframes arrow {
    0% {
      transform: translateY(0rem);
      opacity: 1;
    }
    35% {
      opacity: 1;
    }
    50% {
      transform: translateY(-0.3rem);
      opacity: 0;
    }
    89% {
      transform: translateY(0.1rem);
      opacity: 0;
    }
    100% {
      opacity: 1;
      transform: translateY(0rem);
    }
  }
  svg {
    path {
      fill: ${GREY_800};
    }
    .cls-1 {
      transform: translateY(0rem);
      fill: ${GREY_400};
    }
    path:nth-child(2) {
      animation: arrow 1.5s ease-out infinite backwards;
    }
  }
`;

const Wrapper = styled.div<{ $idle: boolean }>`
  position: absolute;
  width: 100%;
  height: 100%;

  svg {
    display: block;
    width: 3.125rem;
    height: 3.125rem;
  }

  ${({ $idle }) => ($idle ? idleStyle : loadingStyle)}
`;

const StyledInput = styled.input`
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
`;

const FileInputField = ({
  inputRef,
  status,
  loading,
  caption,
  loadingCaption,
  disabled,
  multiple,
  acceptFormats,
  onChange,
}: any) => {
  const { t } = useTranslation();
  const loadingState = status === UPLOADING_STATES.LOADING || loading;

  return (
    <Wrapper $idle={!loadingState}>
      {loadingState ? (
        <IconAndCaption
          disabled={true}
          icon={<Symbols.UploadNoWrapper />}
          caption={loadingCaption || t('components_image-upload_uploading')}
        />
      ) : (
        <>
          <IconAndCaption
            disabled={disabled}
            icon={<Symbols.UploadNoWrapper />}
            caption={caption}
          />
          <StyledInput
            ref={inputRef}
            type="file"
            disabled={disabled}
            onChange={onChange}
            multiple={multiple}
            accept={acceptFormats ? acceptFormats.join(', ') : undefined}
            aria-label="file-input-field"
            data-is-file-uploader
          />
        </>
      )}
    </Wrapper>
  );
};

export default FileInputField;
